import React, { useEffect, useState } from "react";
import "./ActionPlan.css";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../firebase";
import { collection, addDoc, deleteDoc, updateDoc, doc, query, where, getDocs, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const GeneralNotesheet = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, []);

  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
  const [budgetData, setBudgetData] = useState({
    ageneral: 0, ascsp: 0, anicra: 0, acfldo: 0, acfldp: 0, anf: 0, asponsored: 0, anabard: 0, aarya: 0, aosmv: 0, aseedhub: 0, aatma: 0, auniversity: 0,
    ugeneral: 0, uscsp: 0, unicra: 0, ucfldo: 0, ucfldp: 0, unf: 0, usponsored: 0, unabard: 0, uarya: 0, uosmv: 0, useedhub: 0, uatma: 0, uuniversity: 0,
    bgeneral: 0, bscsp: 0, bnicra: 0, bcfldo: 0, bcfldp: 0, bnf: 0, bsponsored: 0, bnabard: 0, barya: 0, bosmv: 0, bseedhub: 0, batma: 0, buniversity: 0,
  });

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  // Fetch budget data from Firestore
  const fetchBudgetData = async () => {
    try {
      const budgetRef = doc(db, "empmaster", empId, String(document.getElementById("dd3").value), "budget");
      const docSnap = await getDoc(budgetRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setBudgetData({
          ageneral: data.ageneral || 0, ascsp: data.ascsp || 0, anicra: data.anicra || 0, acfldo: data.acfldo || 0, acfldp: data.acfldp || 0, anf: data.anf || 0, asponsored: data.asponsored || 0, anabard: data.anabard || 0, aarya: data.aarya || 0, aosmv: data.aosmv || 0, aseedhub: data.aseedhub || 0, aatma: data.aatma || 0, auniversity: data.auniversity || 0,
          ugeneral: data.ugeneral || 0, uscsp: data.uscsp || 0, unicra: data.unicra || 0, ucfldo: data.ucfldo || 0, ucfldp: data.ucfldp || 0, unf: data.unf || 0, usponsored: data.usponsored || 0, unabard: data.unabard || 0, uarya: data.uarya || 0, uosmv: data.uosmv || 0, useedhub: data.useedhub || 0, uatma: data.uatma || 0, uuniversity: data.uuniversity || 0,
          bgeneral: data.bgeneral || 0, bscsp: data.bscsp || 0, bnicra: data.bnicra || 0, bcfldo: data.bcfldo || 0, bcfldp: data.bcfldp || 0, bnf: data.bnf || 0, bsponsored: data.bsponsored || 0, bnabard: data.bnabard || 0, barya: data.barya || 0, bosmv: data.bosmv || 0, bseedhub: data.bseedhub || 0, batma: 0, buniversity: data.buniversity || 0,
        });
      } else {
        console.log("No budget data found.");
      }
    } catch (error) {
      console.error("Error fetching budget data:", error);
    }
  };

  useEffect(() => {
    console.log(empId)
    const fetchActionPlan = async () => {
      if (!month || !year) return;
      try {
        console.log("Fetching action plans for month:", month);
        const q = query(collection(db, "actionplan"), where("empid", "==", empId), where("month", "==", String(month + " " + year)), where("notesheettype", "==", "general"));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          console.log("No action plans found for the selected month.");
          setActionPlan([]);
          return;
        }
        const actions = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          const accDate = data.accdate?.toDate ? data.accdate.toDate().toLocaleDateString('en-GB') : "";
          return {
            id: doc.id,
            code: data.programCode || "",
            subject: data.program || "",
            td: data.td || "",
            text: data.budgetdemand || "",
            budgethead: data.budgethead || "",
            totamount: data.totamount || "",
            accdate: accDate,
            currentstatus: data.currentstatus || "",
            supportdoc: data.supportdoc || "", // Fetch supportdoc field
            saved: true,
            notesheettype: 'general'
          };
        });
        console.log("Fetched action plans:", actions);
        setActionPlan(actions);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };
    fetchActionPlan();
  }, [month, year]);

  const handleAddAction = () => {
    setActionPlan([...actionPlan, { code: "", subject: "", td: "", text: "", budgethead: "", totamount: "", supportdoc: "", saved: false, id: null }]);
  };

  const handleFileUpload = async (index, file) => {
    if (!file) return;

    const fileRef = ref(storage, `uploads/${empId}/${month}_${year}/supportdoc_${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);

    const updatedActions = [...actionPlan];
    updatedActions[index].supportdoc = fileURL;
    setActionPlan(updatedActions);

    return fileURL;
  };

  const handleSaveAction = async (index) => {
    if (!month || actionPlan[index].subject.trim() === "" || actionPlan[index].code.trim() === "" || !actionPlan[index].budgethead || !actionPlan[index].totamount) {
      alert("Please select a month, budget head, enter program code, notesheet subject, and total amount before saving.");
      return;
    }
    try {
      const today = new Date()
      const docRef = await addDoc(collection(db, "actionplan"), {
        notesheettype: 'general',
        finalapproval: "No",
        empid: empId,
        month: month + " " + year,
        programCode: actionPlan[index].code,
        program: actionPlan[index].subject,
        td: actionPlan[index].td,
        budgetdemand: actionPlan[index].text,
        budgethead: actionPlan[index].budgethead,
        totamount: actionPlan[index].totamount,
        supportdoc: actionPlan[index].supportdoc || "", // Save supportdoc field
        currentstatus: `Forwarded to Accountant on ${today.toLocaleDateString('en-GB')}`,
        cs: 0,
        acsettlement: 'No',
        tsurl: "",
        accremarks: "",
        ddoremarks: "",
        sshremarks: "",
        deeremarks: "",
        demanddate: new Date(),
        accdate: new Date(),
        ddodate: new Date(),
        sshdate: new Date(),
        deedate: new Date(),
        vcapproval: "No",
        budgetapproved: 0,
        kvk: String(localStorage.getItem("kvk")),
        empname: String(localStorage.getItem("empname")),
        empdesig: String(localStorage.getItem("empdesig")),
      });
      const updatedActions = [...actionPlan];
      updatedActions[index].saved = true;
      updatedActions[index].id = docRef.id;
      updatedActions[index].accdate = new Date().toLocaleDateString('en-GB');
      setActionPlan(updatedActions);
    } catch (error) {
      console.error("Error saving program:", error);
    }
  };

  const handleDeleteAction = async (index) => {
    if (actionPlan[index].id) {
      try {
        await deleteDoc(doc(db, "actionplan", actionPlan[index].id));
      } catch (error) {
        console.error("Error deleting program:", error);
      }
    }
    const updatedActions = actionPlan.filter((_, i) => i !== index);
    setActionPlan(updatedActions);
  };

    const handleBack =(e)=>{
    e.preventDefault();
    navigate(-1)
  }

  return (
    <div className="container">
      <h1 className="welcome">Notesheet of {name || "User"}</h1>

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label className="label">Select Month and Year:</label>
          <select className="dropdown" id="dd1" value={month} onChange={(e) => setMonth(e.target.value)}>
            <option value="">Month</option>
            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        <select className="dropdown" id="dd2" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: '150px', height: '40px', marginTop: '33px' }}>
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {month && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th style={{ width: '120px' }}>Budget Head</th>
                <th style={{ width: '150px' }}>Reference No.</th>
                <th>Notesheet Details</th>
                <th style={{ width: '120px' }}>Action</th>
                <th style={{ width: '120px' }}>Supporting Document</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action, index) => (
                <tr key={index}>
                  <td>
                    <select
                      style={{ height: '38px', backgroundColor: 'white' }}
                      value={action.budgethead}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].budgethead = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      disabled={action.saved}
                    >
                      <option value="">Select</option>
                      <option value="General">General</option>
                      <option value="SCSP">SCSP</option>
                      <option value="NICRA">NICRA</option>
                      <option value="CFLD Oilseed">CFLD Oilseed</option>
                      <option value="CFLD Pulse">CFLD Pulse</option>
                      <option value="Natural Farming">Natural Farming</option>
                      <option value="Sponsored Program">Sponsored Program</option>
                      <option value="NABARD">NABARD</option>
                      <option value="ARYA">ARYA</option>
                      <option value="Oilseed Mission Village">Oilseed Mission Village</option>
                      <option value="Seed Hub">Seed Hub</option>
                      <option value="ATMA">ATMA</option>
                      <option value="Others">Others</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      value={action.code}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].code = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      className="input-box"
                      disabled={action.saved}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="Write Notesheet Subject"
                      value={action.subject}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].subject = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      className="input-box"
                      disabled={action.saved}
                    />
                    <textarea
                      rows="4"
                      type="text"
                      maxLength={750}
                      placeholder="Write Technical Details"
                      value={action.td}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].td = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      className="input-box"
                      disabled={action.saved}
                    />
                    <textarea
                      rows="4"
                      type="text"
                      maxLength={750}
                      placeholder="Write Budget Breakup"
                      value={action.text}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].text = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      className="input-box"
                      disabled={action.saved}
                    />
                    <input
                      type="number"
                      placeholder="Enter Total Amount (Only number)"
                      value={action.totamount}
                      onChange={(e) => {
                        const updatedActions = [...actionPlan];
                        updatedActions[index].totamount = e.target.value;
                        setActionPlan(updatedActions);
                      }}
                      className="input-box"
                      disabled={action.saved}
                    />
                  </td>
                  <td>
                    <button
                      className={action.saved ? "delete-btn" : "save-btn"}
                      onClick={() => (action.saved ? handleDeleteAction(index) : handleSaveAction(index))}
                    >
                      {action.saved ? "Delete" : "Save"}
                    </button>
                    {action.saved && (
                      <div>
                        {action.currentstatus}
                      </div>
                    )}
                  </td>
                  <td>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      style={{ width: "100px" }}
                      onChange={async (e) => {
                        const fileURL = await handleFileUpload(index, e.target.files[0]);
                        if (fileURL && action.saved) {
                          // Update Firestore if the action is already saved
                          try {
                            const actionRef = doc(db, "actionplan", action.id);
                            await updateDoc(actionRef, { supportdoc: fileURL });
                          } catch (error) {
                            console.error("Error updating supportdoc:", error);
                          }
                        }
                      }}
                      disabled={action.saved && action.supportdoc} // Disable if already uploaded
                    />
                    {action.supportdoc && (
                      <a href={action.supportdoc} target="_blank" rel="noopener noreferrer">
                        View Document
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="add-btn" onClick={handleAddAction}>Initiate Notesheet</button>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />
    </div>

  );
};

export default GeneralNotesheet;